import { AxiosResponse } from 'axios';
import { UDNICK } from '../../../../service/udnick';

interface IClienteTransportadora {
  codParc: number;
  nome: string;
  cnpjCpf: string;
  identidade: string;
}

export interface IClienteTransportadoraResponse {
  clientes: IClienteTransportadora[];
  total: number;
}

export const SelectClientesTransportadorasServices = {
  getClientesTransportadoras: (
    parceiros: number[]
  ): Promise<AxiosResponse<IClienteTransportadoraResponse>> =>
    UDNICK.callService('getClientesTransportadoras', {
      parceiros,
    }),
};
